import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class BookmarkSalary {
  bookmark(id, isPosting, module) {
    const body = {
      unique_id: id,
      module: module,
      is_bookmark: isPosting,
    };

    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/bookmark`;
    return axios.post(url, body, headersTokenConfig);
  }
}

export default new BookmarkSalary();
